import React from 'react';

export default function CowEarsSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="32.11,4.84 28.13,8.82 25.29,5.98 29.27,2.0" fill="#E3C7B5" />
      <polygon points="11.63,8.82 7.65,4.84 10.49,2.0 14.47,5.98" fill="#E3C7B5" />
      <polygon points="36.32,32.14 28.89,35.22 26.43,29.28 33.86,26.2" fill="#E3C7B5" />
      <polygon points="36.32,32.14 28.89,35.22 26.43,29.28 33.86,26.2" fill="#E3C7B5" />
      <polygon points="11.11,35.22 3.68,32.14 6.14,26.2 13.57,29.28" fill="#E3C7B5" />
      <polygon points="11.11,35.22 3.68,32.14 6.14,26.2 13.57,29.28" fill="#E3C7B5" />
      <polygon points="34.7,31.51 28.76,33.97 26.91,29.52 32.86,27.06" fill="#E3C7B5" />
      <polygon points="28.76,33.97 34.7,31.51 34.22,31.27 28.28,33.73" fill="#C68F6B" opacity="0.95" />
      <polygon points="28.76,33.97 28.28,33.73 26.43,29.28 26.91,29.52" fill="#C68F6B" opacity="0.95" />
      <polygon points="12.2,33.97 6.26,31.51 8.11,27.06 14.05,29.52" fill="#E3C7B5" />
      <polygon points="6.26,31.51 5.78,31.27 7.62,26.81 8.11,27.06" fill="#C68F6B" opacity="0.95" />
      <polygon points="29.01,36.83 28.2,36.83 28.2,35.23 29.01,35.23" fill="#E3C7B5" />
      <polygon points="29.73,35.59 28.93,35.59 28.93,34.78 29.73,34.78" fill="#E3C7B5" />
      <polygon points="28.93,35.59 27.96,35.11 27.96,34.3 28.93,34.78" fill="#C68F6B" opacity="0.95" />
      <polygon points="29.73,38.0 28.93,38.0 28.93,37.2 29.73,37.2" fill="#E3C7B5" />
      <polygon points="28.93,38.0 27.96,37.52 27.96,36.71 28.93,37.2" fill="#C68F6B" opacity="0.95" />
      <polygon points="29.73,37.2 28.93,37.2 28.93,35.59 29.73,35.59" fill="#E3C7B5" />
    </svg>
  );
}
